export enum ControlTypes {
    Textbox = 'Textbox',
    Radio = 'Radio',
    MultiTextbox = 'MultiTextbox',
    MultiQuestionbox = 'MultiQuestionbox',
    CustomAnswerRadio = 'CustomAnswerRadio',
    Slider = 'Slider',
    Stepper = 'Stepper',
    Checkbox = 'Checkbox',
    CheckboxSet = 'CheckboxSet',
    Dropdown = 'Dropdown',
    SearchDropdown = 'SearchDropdown',
    Addressbox = 'Addressbox',
    AdvancedSearch = 'AdvancedSearch'
}
